import request from "@/utils/request";

//获取智能体初始化列表
export async function getAgentList(params: any) {
  return request("/api/v1/agent/init", {
    method: "GET",
    params,
  });
}

//AI回答用户问题
export async function getAnswerQuestion(
  params: any,
  onData: (chunk: string) => void
) {
  try {
    const response = request("/api/v1/agent/converse", {
      method: "POST",
      data: params,
      responseType: "stream",
      onDownloadProgress: (progressEvent) => {
        // 处理流式数据
        // 接收数据，去除首尾换行符，解析json数据，获取消息列表
        const chunk = progressEvent.event.currentTarget.response.replace(
          /^\s+|\s+$/g,
          ""
        );
        const lines = chunk.split("\n");
        // 将最后一行数据解析为json数据，获取消息列表
        const json = JSON.parse(lines[lines.length - 1]);
        onData(json);
      },
    });
    return response;
  } catch (error) {
    console.error("请求出错:", error);
    throw error;
  }
}

//切换语言接口
export async function switchLanguages(params: any) {
  return request("/api/v1/agent/change-lang", {
    method: "POST",
    data: params,
  });
}

//关闭会话
export async function closeSession(params: any) {
  return request("/api/v1/agent/close", {
    method: "POST",
    data: params,
  });
}

//打开会话
export async function openSession(params: any) {
  return request("/api/v1/agent/open", {
    method: "POST",
    data: params,
  });
}

//连接websocket
export async function connectWebsocket(params: any) {
  return request("/api/v1/agent/customer/connect", {
    method: "POST",
    data: params,
  });
}

//上传附件
export async function uploadFile(params: any) {
  return request("/api/v1/upload", {
    method: "POST",
    data: params,
  });
}

//删除附件
export async function deleteFile(params: any) {
  return request("/api/v1/agent/file/remove", {
    method: "DELETE",
    data: params,
  });
}

//提交帖子
export async function submitTicket(params: any) {
  return request("/api/v1/agent/ticket", {
    method: "POST",
    data: params,
  });
}

//产品列表数据
export async function getProductList(params: any) {
  return request("/api/v1/agent/product/list", {
    method: "GET",
    params,
  });
}

//用户给客服评分
export async function EditRateCustomerService(params: any) {
  return request("/api/v1/agent/grade", {
    method: "POST",
    data: params,
  });
}

//消息下方点赞
export async function editPraise(params: any) {
  return request("/api/v1/agent/thumb", {
    method: "POST",
    data: params,
  });
}

//智能体满意度调查
export async function editAgentSatisfaction(params: any) {
  return request("/api/v1/agent/satisfaction", {
    method: "POST",
    data: params,
  });
}

//智能体-获取问候语
export async function getAgentGreeting(params: any) {
  return request("/api/v1/agent/greeting", {
    method: "GET",
    params,
  });
}

//临时聊天-创建 https://yapi.yunwei-afs.com/project/180/interface/api/33093
export async function addTempChat(params: any) {
  return request("/api/v1/tmp/chat/create", {
    method: "POST",
    data: params,
  });
}

//临时聊天-初始化 https://yapi.yunwei-afs.com/project/180/interface/api/32946
export async function getAgentTempChatInitList(params: any) {
  return request("/api/v1/tmp/chat/init", {
    method: "POST",
    data: params,
  });
}

//临时聊天-对话 https://yapi.yunwei-afs.com/project/180/interface/api/33093
export async function tempChatConverse(params: any) {
  return request("/api/v1/tmp/chat/converse", {
    method: "POST",
    data: params,
  });
}

//临时聊天-消息轮询
export async function getAgentTempChatPolling(params: any) {
  return request("/api/v1/tmp/chat/query", {
    method: "POST",
    data: params,
  });
}
